import { ConfirmModal } from '@/components/modal/ConfirmModal'

type Props = {
  onConfirm: () => void
  onCancel: () => void
}

export const CancelFormConfirmModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <ConfirmModal
      title="確認"
      titleColor="blue"
      message={
        <>
          入力内容を破棄して一覧画面に戻ってよろしいですか？
        </>
      }
      confirmLabel="一覧画面に戻る"
      cancelLabel="いいえ"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
